var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption grey--text text--darken-1"},[(_vm.muser && _vm.mdate)?_c('div',[_c('strong',[_vm._v("Ultima modifica")]),_vm._v(" "+_vm._s(_vm.muser)+", "+_vm._s(_vm.mdate)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }